// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__d6joQ","footerBox":"Footer_footerBox__WlODi"};